<hpf-module-qcm-form
	*ngIf="moduleQCM"
	[moduleQCM]="moduleQCM"
	[loading]="moduleQCM.isNew()"
	(update)="onUpdate()"
	(delete)="onDelete()"
></hpf-module-qcm-form>
